/**
 * Created by tomers on 6/15/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Media = require("media");
    var template = require("personalization-web-agent-templates/away-reasons/awayReasonEditItemDialogView.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");

    var AwayReasonEditItemDialogView = {};

    function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {
        AwayReasonEditItemDialogView = Marionette.ItemView.extend({
            className: "away-reason-edit-dialog",
            template: template,
            ui: {
                title: ".away-reason-title",
                text: ".away-reason-text-container",
                cancelButton: ".button-cancel",
                saveButton: ".button-save"
            },
            uiComponents: {
                text: {
                    type: InputField,
                    options: {
                        permutation: InputField.Permutation.O,
                        el: "view.ui.text",
                        placeholder: LE.translator.translate("LEPersonalization.webAgent.agentState.edit.awayReasons.dialog.placeholder"),
                        maxLength: "view.model.MAX_TEXT_LENGTH",
                        theme: InputField.THEME.NIGHT
                    },
                    events: {
                        change: "_onTextChange",
                        enterPressed: "_onEnterKeyPress"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        initState: Button.STATES.ENABLED,
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSaveClick"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK_NIGHT
                    },
                    events: {
                        "click": "_onCancelClick"
                    }
                }
            },
            modelEvents: {
                "change:text": "_updateSaveButtonState"
            },

            initialize: function(options) {
                options = options || {};
                this.channel = Media.channel(LE.mediaCodes.personalization.channels.AWAY_REASONS);
            },

            onRender: function() {
                this._updateTitle();
                this._updateText();
                this._updateSaveButtonState();

                this.uiComponents.text.setFocus(true);

                this.listenTo(this, "dialog:closeButtonClick", this._onCancelClick);
            },

            _updateTitle: function() {
                var title = this.model.isNew() ? LE.translator.translate("LEPersonalization.webAgent.agentState.edit.awayReasons.dialog.new.title") : LE.translator.translate("LEPersonalization.webAgent.agentState.edit.awayReasons.dialog.edit.title");
                this.ui.title.text(title);
            },

            _updateText: function() {
                var reasonText = this.model.getText();
                this.uiComponents.text.setValue(reasonText);
            },

            _updateSaveButtonState: function() {
                var isModelValid = this.model.validateSaveEnabled();
                var isModelChanged = this.model.isValueChanged();
                if (!isModelValid) {
                    this.uiComponents.saveButton.setEnabled(false);
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEFramework.entities.agentReason.errors.text.required"));
                }
                else if (!isModelChanged) {
                    this.uiComponents.saveButton.setEnabled(false);
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEFramework.entities.agentReason.errors.text.noChanges"));
                }
                else {
                    this.uiComponents.saveButton.setEnabled(true);
                    this.uiComponents.saveButton.setTooltip("");
                }
            },

            _onTextChange: function(componentName, eventName, value) {
                var text = value.trim();
                this.channel.trigger("awayReasons:dialog:change:text", text);
            },

            _onSaveClick: function() {
                LEPersonalization.logger.debug("save in away reason dialog is clicked", "AwayReasonEditItemDialogView:_onSaveClick");
                this.channel.trigger("awayReasons:dialog:save");
            },

            _onCancelClick: function() {
                LEPersonalization.logger.debug("cancel in away reason dialog is clicked", "AwayReasonEditItemDialogView:_onCancelClick");
                this.channel.trigger("awayReasons:dialog:cancel");
            },

            onInvalid: function(model, errors) {
                this._clearErrors();

                if (_.has(errors, model.KEYS.TEXT)) {
                    this.uiComponents.text.setError(true, errors[model.KEYS.TEXT]);
                }
            },

            _onEnterKeyPress: function() {
                this._onSaveClick();
            },

            _clearErrors: function() {
                this.uiComponents.text.setError(false);
            }
        });
    }

    LE.module("LEPersonalization", moduleDefinition);

    return AwayReasonEditItemDialogView;
});
